var app = angular.module("leonardo");

var PortfolioAddDialog = function($scope, $rootScope, ngDialog, PortfolioService, FormErrorsService) {
  $scope.mode = $scope.ngDialogData.mode;


  if ($scope.mode === 'edit'){
    $scope.data = angular.copy($scope.ngDialogData.portfolio);
  }
  else
    $scope.data = {
      account: $scope.ngDialogData.account
    };

  $scope.clearError = function () {
    $scope.Form.name.$setValidity('unique', true);
  };


  $scope.getData = function () {
    var data = angular.copy($scope.data);
    if ($scope.data.groups) {
      var group_Ids = [];
      angular.forEach($scope.data.groups, function(group){
        group_Ids.push(group.id);
      });
      data['groups'] = group_Ids;
    }
    else {
      data['groups'] = [];
    }
    return data;
  };


  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    if ($scope.mode === 'edit'){
      $scope.ngDialogData.portfolio.patch(data).then(function(portfolio){
        PortfolioService.updateCollection(portfolio);
        $rootScope.$broadcast('portfolio:updated', portfolio);
        $scope.closeThisDialog();
      },function(error){
        setValidity(error);
      });
    }
    else {
      PortfolioService.post(data).then(function(portfolio) {
        PortfolioService.updateCollection(portfolio);
        $rootScope.$broadcast('portfolio:added', portfolio);
        $scope.closeThisDialog();
      },function(error){
        setValidity(error);
      });
    }
  };

  function setValidity(error){
    if (error.data.name){
      $scope.Form.name.$setValidity('unique', false);
    }
  }
};

app.controller('PortfolioAddDialog', ['$scope', '$rootScope', 'ngDialog', 'PortfolioService', 'FormErrorsService',
  PortfolioAddDialog]);
